import script from "./MusicGame.vue?vue&type=script&setup=true&lang=js"
export * from "./MusicGame.vue?vue&type=script&setup=true&lang=js"

import "./MusicGame.vue?vue&type=style&index=0&id=f1aac9fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1aac9fa"]])

export default __exports__